import { createQueryKeys } from "@lukemorales/query-key-factory";

import MasterApiBase from "./master-api.base";

export default class CustomerRegistrationsApi extends MasterApiBase {
	#findAll = (params = {}) => {
		return this.axios.get(this.endpoints.customerRegistrations, {
			params,
		});
	};

	queryKeys = createQueryKeys("customerRegistrations", {
		list: (filters) => ({
			queryKey: [{ filters }],
			queryFn: () => this.#findAll(filters),
		}),
	});
}
